import React from 'react';
import BasicButton from './BasicButton';
import { defaultButton } from '@styles/app';

const DefaultButton: React.FC<any> = (props): JSX.Element => {
  return <BasicButton {...props} variant={defaultButton} />;
};

export default DefaultButton;
